(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.dataset.ojReady === 'true') return;
    root.dataset.ojReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.order-journey__step'));
    if (!steps.length) return;

    function cycle() {
      var index = 0;
      // One extra frame with nothing active, so the loop reads as a pause not a jump
      setInterval(function () {
        steps.forEach(function (step, position) {
          step.classList.toggle('is-active', position === index);
          // Connectors stay filled behind the highlight, then clear on the pause frame
          step.classList.toggle('is-done', index < steps.length && position <= index);
        });
        index = (index + 1) % (steps.length + 1);
      }, 1400);
    }

    function reveal() {
      root.classList.add('is-visible');
      if (!reduceMotion && root.dataset.loop === 'true') {
        setTimeout(cycle, 700);
      }
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.order-journey').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders sections on every setting change
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
